const DEFAULT_TRANSITION_DURATION = 0;

function getHeaderBottom() {
  const headerSection = document.querySelector('#shopify-section-header');
  const header = headerSection
    ? headerSection.querySelector('header')
    : document.querySelector('header');
  if (!header) return 0;
  return header.getBoundingClientRect().bottom;
}

function computeTargetRect(sourceRect) {
  const viewportWidth = window.innerWidth;
  const isLg = window.matchMedia('(min-width: 1024px)').matches;
  const isMd = window.matchMedia('(min-width: 768px)').matches;
  const headerBottom = getHeaderBottom();

  if (isMd) {
    const offsetTop = headerBottom + 48;
    const gap = 24;
    // Compute inner width respecting max-w-7xl (80rem = 1280px) on pdp-nav-transition__inner
    const innerWidth = Math.min(viewportWidth, 1280);
    // Match Tailwind md:w-7/12 and lg:w-3/5 relative to inner element
    const leftColumnWidth = isLg ? innerWidth * (3 / 5) : innerWidth * (7 / 12);
    const panelWidth = Math.max(innerWidth - leftColumnWidth - gap, 220);

    return {
      left: 0,
      top: offsetTop,
      width: leftColumnWidth,
      height: 'auto',
      overlayPaddingTop: offsetTop,
      panelLeft: leftColumnWidth + gap,
      panelTop: offsetTop,
      panelWidth,
    };
  }

  const offsetTop = headerBottom;
  const mediaWidth = Math.max(viewportWidth, sourceRect.width * 1.2);
  const imageRatio =
    sourceRect.width > 0 ? sourceRect.height / sourceRect.width : 1;
  const estimatedAutoHeight = mediaWidth * imageRatio;

  return {
    left: 0,
    top: offsetTop,
    width: mediaWidth,
    height: 'auto',
    overlayPaddingTop: offsetTop,
    panelLeft: 16,
    panelTop: offsetTop + estimatedAutoHeight + 16,
    panelWidth: Math.max(viewportWidth - 32, 220),
  };
}

function createNavigationOverlay(imageForTransition, sourceRect) {
  const overlay = document.createElement('div');
  overlay.className = 'pdp-nav-transition';
  overlay.setAttribute('aria-hidden', 'true');

  const imageShell = document.createElement('div');
  imageShell.className =
    'pdp-nav-transition__image-shell w-full md:w-7/12 lg:w-3/5 min-w-0';
  // Note: width is NOT set here — it is set in start() after measuring natural position

  // Grid wrapper matching product-images layout
  const imageGrid = document.createElement('div');
  imageGrid.className =
    'w-full md:grid md:grid-cols-[3rem_minmax(0,1fr)] lg:grid-cols-[5rem_minmax(0,1fr)] 2xl:grid-cols-[6rem_minmax(0,1fr)] md:items-stretch md:gap-1 lg:gap-3';

  // Thumbnail column — visible from md only
  const thumbsCol = document.createElement('div');
  thumbsCol.className = 'hidden md:flex md:flex-col gap-1 lg:gap-3';
  for (let i = 0; i < 5; i++) {
    const thumb = document.createElement('div');
    thumb.className =
      'pdp-nav-transition__line aspect-square w-full shrink-0 rounded-lg lg:rounded-2xl';
    thumbsCol.appendChild(thumb);
  }

  // Main image column
  const mainCol = document.createElement('div');
  mainCol.className = 'min-w-0';
  const mainWrap = document.createElement('div');
  mainWrap.className =
    'aspect-square md:rounded-3xl lg:rounded-4xl overflow-hidden';
  const transitionImage = imageForTransition.cloneNode(true);
  transitionImage.classList.add('pdp-nav-transition__image');
  transitionImage.classList.remove('group-hover:scale-105');
  transitionImage.removeAttribute('sizes');
  mainWrap.appendChild(transitionImage);
  mainCol.appendChild(mainWrap);

  imageGrid.appendChild(thumbsCol);
  imageGrid.appendChild(mainCol);
  imageShell.appendChild(imageGrid);

  const panel = document.createElement('div');
  panel.className =
    'pdp-nav-transition__panel w-full md:w-5/12 lg:w-2/5 min-w-0';
  panel.innerHTML = `
    <div class="pdp-nav-transition__line pdp-nav-transition__line--vendor w-[15%] h-3.5 mb-3.5"></div>
    <div class="pdp-nav-transition__line pdp-nav-transition__line--title w-full lg:w-[78%] h-8 mb-3.5"></div>
    <div class="pdp-nav-transition__line pdp-nav-transition__line--label w-[25%] h-3.5 mb-4"></div>
    <div class="pdp-nav-transition__line pdp-nav-transition__line--price w-[40%] h-3.5"></div>
    <div class="w-full py-6 my-6 border-y border-border">
      <div class="pdp-nav-transition__line pdp-nav-transition__line--description w-full h-16"></div>
    </div>
    <div class="pdp-nav-transition__line pdp-nav-transition__line--option-title w-[15%] h-3.5 mb-2"></div>
    <div class="pdp-nav-transition__line pdp-nav-transition__line--option-block w-full h-30 mb-3.5"></div>
    <div class="pdp-nav-transition__line pdp-nav-transition__line--stock-info w-[10%] h-3.5 mb-3"></div>
    <div class="w-full flex gap-2.5">
      <div class="pdp-nav-transition__line pdp-nav-transition__line--atc rounded-full! flex-1 h-12 mb-3"></div>
      <div class="pdp-nav-transition__line pdp-nav-transition__line--wishlist rounded-full! w-12 h-12"></div>
    </div>
    <div class="pdp-nav-transition__line pdp-nav-transition__line--buy-now rounded-full! w-full h-12"></div>
  `;

  const inner = document.createElement('div');
  inner.className =
    'pdp-nav-transition__inner max-w-7xl mx-auto flex flex-col md:flex-row gap-4.5 sm:gap-5 lg:gap-5 xl:gap-8';

  const target = computeTargetRect(sourceRect);
  overlay.style.paddingTop = `${target.overlayPaddingTop}px`;

  inner.appendChild(imageShell);
  inner.appendChild(panel);
  overlay.appendChild(inner);

  return { overlay, imageShell, target };
}

function cleanupOverlays() {
  document.querySelectorAll('.pdp-nav-transition').forEach((node) => {
    node.remove();
  });
}

function ensureCleanupBound() {
  if (window.__pdpNavTransitionCleanupBound) return;
  window.addEventListener('pageshow', cleanupOverlays);
  window.__pdpNavTransitionCleanupBound = true;
}

function shouldAnimateNavigation(event, link) {
  if (!event || !link) return false;
  if (event.defaultPrevented) return false;
  if (event.button !== 0) return false;
  if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
    return false;
  }

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return false;
  }

  if (link.target && link.target !== '_self') {
    return false;
  }

  return true;
}

function start({ event, link, image, duration = DEFAULT_TRANSITION_DURATION }) {
  if (!shouldAnimateNavigation(event, link)) {
    return false;
  }

  if (!image) {
    return false;
  }

  const sourceRect = image.getBoundingClientRect();
  if (sourceRect.width <= 0 || sourceRect.height <= 0) {
    return false;
  }

  event.preventDefault();

  cleanupOverlays();

  const transitionPayload = createNavigationOverlay(image, sourceRect);
  const { overlay, imageShell, target } = transitionPayload;

  document.body.appendChild(overlay);

  // Measure the shell's natural layout position (CSS-determined, no inline overrides yet).
  const naturalRect = imageShell.getBoundingClientRect();
  const targetWidth = naturalRect.width || target.width;

  // Snap the shell to the source image position — disable transition first so the
  // initial placement is instantaneous (no accidental animation from default state).
  const dx = sourceRect.left - naturalRect.left;
  const dy = sourceRect.top - naturalRect.top;
  imageShell.style.transition = 'none';
  imageShell.style.width = `${sourceRect.width}px`;
  imageShell.style.transform = `translate(${dx}px, ${dy}px)`;

  // Force a reflow so the browser commits the snapped state before we re-enable transitions.
  imageShell.getBoundingClientRect();

  // Re-enable CSS transitions, then animate to natural position in next frame.
  imageShell.style.transition = '';
  requestAnimationFrame(() => {
    imageShell.style.width = `${targetWidth}px`;
    imageShell.style.transform = '';
    overlay.classList.add('pdp-nav-transition--active');
  });

  window.setTimeout(
    () => {
      window.location.href = link.href;
    },
    Math.max(0, duration),
  );

  return true;
}

ensureCleanupBound();

window.PdpNavigationTransition = {
  start,
  cleanup: cleanupOverlays,
};
